import { createClient } from '@libsql/client';
import { nanoid } from 'nanoid';

const db = createClient({
  url: import.meta.env.VITE_TURSO_DB_URL,
  authToken: import.meta.env.VITE_TURSO_AUTH_TOKEN
});

const DEFAULT_HERO_SLIDES = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?ixlib=rb-4.0.3&auto=format&fit=crop&w=2400&q=80",
    title: "Discover Your Dream Property",
    subtitle: "Your trusted partner in real estate, helping you find the perfect place to call home in India.",
    updated_at: new Date().toISOString() 
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2400&q=80",
    title: "Luxury Living Redefined",
    subtitle: "Experience the finest properties with world-class amenities and stunning locations.",
    updated_at: new Date().toISOString() 
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2400&q=80",
    title: "Premium Properties",
    subtitle: "Explore our curated collection of high-end properties across India's most sought-after locations.",
    updated_at: new Date().toISOString() 
  }
];

export const heroService = {
  async getHeroSlides() {
    try {
      const result = await db.execute("SELECT id, image_url, title, subtitle, order_index, updated_at FROM hero_slides ORDER BY order_index ASC");
      
      if (result.rows.length === 0) {
        console.warn('No hero slides found in database, returning default slides.');
        return DEFAULT_HERO_SLIDES; 
      }

      return result.rows.map(row => ({
        id: row.id,
        image: row.image_url,
        title: row.title,
        subtitle: row.subtitle,
        order_index: row.order_index,
        updated_at: row.updated_at 
      }));
    } catch (error) {
      console.error('Error fetching hero slides:', error);
      return DEFAULT_HERO_SLIDES;
    }
  },

  async createHeroSlide(slide) {
    const id = nanoid();
    const now = new Date().toISOString(); 
    try {
      await db.execute({
        sql: `INSERT INTO hero_slides (id, image_url, title, subtitle, order_index, updated_at) VALUES (?, ?, ?, ?, ?, ?)`,
        args: [
          id,
          slide.image,
          slide.title,
          slide.subtitle || null,
          slide.order_index || 0,
          now 
        ],
      });
      return this.getHeroSlideById(id);
    } catch (error) {
      console.error('Error creating hero slide:', error);
      throw error;
    }
  },

  async updateHeroSlide(id, slide) {
    const now = new Date().toISOString(); 
    try {
      await db.execute({
        sql: `UPDATE hero_slides SET image_url = ?, title = ?, subtitle = ?, order_index = ?, updated_at = ? WHERE id = ?`,
        args: [
          slide.image,
          slide.title,
          slide.subtitle || null,
          slide.order_index || 0,
          now, 
          id
        ],
      });
      return this.getHeroSlideById(id);
    } catch (error) {
      console.error('Error updating hero slide:', error);
      throw error;
    }
  },

  async deleteHeroSlide(id) {
    try {
      await db.execute({
        sql: `DELETE FROM hero_slides WHERE id = ?`,
        args: [id],
      });
      return true;
    } catch (error) {
      console.error('Error deleting hero slide:', error);
      throw error;
    }
  },

  async getHeroSlideById(id) {
    try {
      const result = await db.execute({
        sql: `SELECT id, image_url, title, subtitle, order_index, updated_at FROM hero_slides WHERE id = ?`,
        args: [id],
      });
      const row = result.rows[0];
      if (row) {
        return {
          id: row.id,
          image: row.image_url,
          title: row.title,
          subtitle: row.subtitle,
          order_index: row.order_index,
          updated_at: row.updated_at 
        };
      }
      return null;
    } catch (error) {
      console.error('Error fetching hero slide by ID:', error);
      throw error;
    }
  },
};
